export default __webpack_public_path__ + "static/AvailableMetrics-0443d2df49ef60c4b9ccf3a45209e4d0.png";